var map = {
	"./de.json": 493,
	"./el.json": 2855,
	"./en.json": 2113,
	"./es.json": 3122,
	"./fr.json": 4122,
	"./hi.json": 7517,
	"./history/history.json": 2953,
	"./nl.json": 6580,
	"./pl.json": 3110,
	"./pt.json": 2750,
	"./sk.json": 9796,
	"./zh-CN.json": 4430,
	"./zh-TW.json": 6762
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2196;